import CareEntryListRow from "./Control";
import {CareEntrySearchResult, RelatedTopic} from "@services/monolith/careEntries";

export type ExtendedCareEntrySearchResult = Partial<CareEntrySearchResult & RelatedTopic> & {
  slug: string;
  name: string;
  icon?: string;
  turnaround?: string;
  price?: string;
};

export enum CareEntryRowVariant {
  SM = "sm",
  MD = "md",
  LG = "lg",
}

export default CareEntryListRow;
